import { useEffect, useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";
import { AlertColor } from "@mui/material";

type TaskAttachmentDeleteResult = [
    any | undefined,
    boolean,
    string | null
];
type PostUpdateSignature = (data: any) => void;

const useTaskAttachmentDelete: (taskId?: number, attachmentId?: number, displaySnackbar?: (severity: AlertColor, text: string) => void, postUpdate?: PostUpdateSignature) => TaskAttachmentDeleteResult = (taskId, attachmentId, displaySnackbar, postUpdate) => {
    const [ result, setResult ] = useState<File | string | undefined>();
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(true);    
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {
        const controller = new AbortController();

        const fetchTaskAttachmentDelete = async () => {
            if (user && user.id_token && taskId && attachmentId) {
                setLoading(true);
                try {
                    const resp = await fetcher(`/api/v3/tasks/${taskId}/attachments/${attachmentId}`, {
                        method: 'DELETE',
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json() as any;
                    setResult(data.status);
                    if(displaySnackbar)
                        displaySnackbar("success", "Success! Attachment deleted")

                    if (postUpdate) {
                        postUpdate(attachmentId);
                    }
                } catch (err) {
                    if(displaySnackbar)
                        displaySnackbar("error", "We couldn't delete the attachment. Please try again")
                } finally {
                    if (!controller.signal.aborted)
                        setLoading(false);
                }
            }
        };
        
        fetchTaskAttachmentDelete();
        return () => {
            controller.abort();
            setLoading(false);
        }
    }, [ attachmentId ]);

    return [
        result,
        loading,
        error
    ];
};

export default useTaskAttachmentDelete;